<template>
  <div class="multi-page-shell">
    <div class="page-scale-shell" ref="scaleShell" :style="scaleShellStyle">
      <div class="page-scale-stage" ref="scaleStage" :style="scaleStageStyle">
        <slot />
      </div>
    </div>

    <div class="global-img-container" :style="overlayScaleStyle">
      <div class="service-text" @click="toggleQrcode">
        <img src="https://file.zmxs.com.cn/img/2026-09-0800002.png" alt="二维码入口" class="global-img">
      </div>
      <div class="service-text service-text--space" @click="togglePopup">
        <img src=" https://file.zmxs.com.cn/img/2026-09-0800003.png" alt="客服入口" class="global-img">
      </div>
      <div class="service-text service-text--space" @click="scrollTop">
        <img src="https://file.zmxs.com.cn/img/2026-09-0800001.png" alt="返回顶部" class="global-img">
      </div>
      <div v-show="isQrcode" class="son">
        <img src="https://file.zmxs.com.cn/img/2026-09-0800005.png" alt="客服二维码" class="son-img">
      </div>
    </div>

    <div v-show="isPopupShow" class="service-popup" :style="overlayScaleStyle">
      <div class="popup-wrapper">
        <div class="popup-content">
          <h3>微信扫码联系客服</h3>
          <div class="qrcode-placeholder">
            <img src="https://file.zmxs.com.cn/img/2026-09-0800006.png" alt="客服二维码">
          </div>
          <p>微信扫码添加客服<br>为您提供专业服务</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { determineDeviceType } from '@/plugins/untils.js'

export default {
  name: 'MultiPageShell',
  data() {
    return {
      isPopupShow: false,
      isQrcode: false,
      isPc: true,
      pageBaseWidth: 1920,
      pageScale: 1,
      scaledStageHeight: 0,
      scaleResizeObserver: null,
      scaleFrameId: null,
      viewportResizeHandler: null
    }
  },
  computed: {
    scaleShellStyle() {
      return {
        minHeight: this.scaledStageHeight ? `${this.scaledStageHeight}px` : '100vh'
      }
    },
    scaleStageStyle() {
      return {
        width: `${this.pageBaseWidth}px`,
        transform: `translateX(-50%) scale(${this.pageScale})`
      }
    },
    overlayScaleStyle() {
      return {
        transform: `scale(${this.pageScale || 1})`,
        transformOrigin: 'bottom right'
      }
    }
  },
  mounted() {
    this.viewportResizeHandler = () => {
      this.scheduleScaleUpdate()
    }

    this.isPc = determineDeviceType()
    this.updateScale()
    window.addEventListener('resize', this.viewportResizeHandler)
    this.$nextTick(() => {
      this.setupScaleObserver()
      this.syncStageHeight()
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.viewportResizeHandler)
    if (this.scaleFrameId) {
      cancelAnimationFrame(this.scaleFrameId)
    }
    if (this.scaleResizeObserver) {
      this.scaleResizeObserver.disconnect()
    }
    this.writeGlobalScale(1)
  },
  methods: {
    toggleQrcode() {
      this.isQrcode = !this.isQrcode
      this.isPopupShow = false
    },
    togglePopup() {
      this.isPopupShow = !this.isPopupShow
      this.isQrcode = false
    },
    scrollTop() {
      window.scrollTo(0, 0)
    },
    writeGlobalScale(scale) {
      const normalizedScale = Number(scale.toFixed(4)) || 1
      const previousScale = Number.parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue('--global-page-scale')
      ) || 1
      document.documentElement.style.setProperty('--global-page-scale', normalizedScale)
      window.__GLOBAL_PAGE_SCALE__ = normalizedScale

      if (Math.abs(previousScale - normalizedScale) > 0.0001) {
        window.dispatchEvent(new CustomEvent('global-page-scale-changed', {
          detail: {
            scale: normalizedScale
          }
        }))
      }
    },
    updateScale() {
      const shell = this.$refs.scaleShell
      if (!shell) {
        return
      }

      this.isPc = determineDeviceType()
      this.pageBaseWidth = this.isPc ? 1920 : 750

      const nextScale = shell.clientWidth / this.pageBaseWidth
      this.pageScale = Number(nextScale.toFixed(4)) || 1
      this.writeGlobalScale(this.pageScale)

      this.$nextTick(() => {
        this.syncStageHeight()
      })
    },
    syncStageHeight() {
      const stage = this.$refs.scaleStage
      if (!stage) {
        return
      }

      const stageHeight = stage.scrollHeight || stage.offsetHeight
      this.scaledStageHeight = Math.ceil(stageHeight * this.pageScale)
    },
    scheduleScaleUpdate() {
      if (this.scaleFrameId) {
        cancelAnimationFrame(this.scaleFrameId)
      }

      this.scaleFrameId = requestAnimationFrame(() => {
        this.scaleFrameId = null
        this.updateScale()
      })
    },
    setupScaleObserver() {
      if (typeof ResizeObserver === 'undefined' || !this.$refs.scaleStage) {
        return
      }

      this.scaleResizeObserver = new ResizeObserver(() => {
        this.syncStageHeight()
      })
      this.scaleResizeObserver.observe(this.$refs.scaleStage)
    }
  }
}
</script>

<style scoped>
.multi-page-shell {
  min-height: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow-x: clip;
  position: relative;
}

.page-scale-shell {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.page-scale-stage {
  position: absolute;
  top: 0;
  left: 50%;
  transform-origin: top center;
  will-change: transform;
}

.global-img-container {
  position: fixed;
  right: 10px;
  bottom: 4%;
  z-index: 9999;
}

.service-text--space {
  margin-top: 10px;
}

.son {
  position: absolute;
  right: 120%;
  bottom: -172%;
  width: 128px;
  height: 597px;
  transform: translateY(-50%);
}

.son-img {
  width: 128px;
  height: 597px;
}

.global-img {
  width: 66px;
  height: auto;
  padding-right: 10px;
  opacity: 0.8;
}

.service-popup {
  position: fixed;
  right: 93px;
  bottom: 9%;
  z-index: 9998;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.popup-content {
  width: 158px;
  height: 185px;
  margin-bottom: 10px;
  padding: 11px 23px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.popup-content h3 {
  margin-bottom: 8px;
  font-size: 14px;
  color: #222222;
}

.qrcode-placeholder {
  width: 106px;
  height: 106px;
  margin: 0 auto 10px;
  border: 1px solid #eee;
  background: #f9f9f9;
}

.qrcode-placeholder img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.popup-content p {
  font-size: 10px;
  line-height: 1.5;
  color: #666666;
}
</style>
